<template>
  <div>
    <NuxtLink :to="localePath('/support')">
      <button href="#" class="fixed bottom-16 right-10 z-30 bg-red-600 text-white text-xl px-4 py-2 rounded-full shadow-md hover:bg-red-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
        {{ $t('contact-us') }}
      </button>
    </NuxtLink>
  </div>
</template>
